import { ROOT_TYPE, MissingFieldHandler } from 'relay-runtime'

// See docs: https://relay.dev/docs/guided-tour/reusing-cached-data/filling-in-missing-data/
// This handler is used to handle the node field in the API, so that Relay knows that when
// reading a value via node() or optionalNode(), it should look for the id in the arguments
// and then re-use any known data for that id.
// In other words, this handler teaches Relay that calling node(id: $id) will give back the
// record with that id, so that Relay can display existing data about it if it's already in the store.
const nodeHandler: MissingFieldHandler = {
  kind: 'linked',
  handle(field, record, argValues) {
    // Make sure to add a handler for the node field
    if (
      typeof record?.getType === 'function' &&
      record?.getType() === ROOT_TYPE &&
      (field?.name === 'node' || field?.name === 'optionalNode') &&
      argValues?.id
    ) {
      return argValues.id
    }
    return undefined
  },
}

export const missingFieldHandlers = [
  nodeHandler,
]
